export enum StorageKeys {
  Token = "nuveToken",
  IsPrivacyChecked = "nuveIsPrivacyChecked",
  UserProfile = "nuveUserProfile",
  TechnicianSN = "nuveTechnicianSN",
  UserTemperatureScale = "userTemperatureScale",
  UserTheme = "userTheme",
  UserLogo = "userLogo",
  VerticalMenuOpen = "verticalMenuOpen",
}
